import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n.use(LanguageDetector).init({
  // we init with resources
  resources: {
    sv: {
      translations: {
        dashboardPageTitle: "dashboard",
        incidentsPageTitle: "qualified incidents",
        incidentsWidgetButtonText: "Become a soc plus customer",
        logInToTa: "Login to Technial Analysis to view data",
        incidentsWidgetTitle: "Top 5 Qualified Incidents by prio",
        logSourceWidgetTitle: "Log source status",
        logsPerDayWidgetTitle: "Logs per day",
        logSourcePageTitle: "log sources",
        reportsPageTitle: "reports",
        securityAlertsLastMonthWidgetTitle: "Security alerts last 30 days",
        securityAlertsLastWeekWidgetTitle: "Security alerts last 7 days",
        supportTitle: "support",
        systemStatusWidgetTitle: "System status",
        incidentWidgetSummaryLowHeader: "Low",
        incidentWidgetSummaryMediumHeader: "Medium",
        incidentWidgetSummaryHighHeader: "High",
        incidentWidgetSummaryCriticalHeader: "Critical",
        incidentWidgetSummaryPriority1: "Priority 1",
        incidentWidgetSummaryPriority2: "Priority 2",
        incidentWidgetSummaryPriority3: "Priority 3",
        incidentWidgetSummaryPriority4: "Priority 4",
        incidentWidgetTablePriority: "Priority",
        incidentWidgetTableDate: "Date",
        incidentWidgetTableSubject: "Subject",
        incidentsFilterLabelStatus: "Status: ",
        incidentsFilterLabelPriority: "Priority: ",
        incidentsFilterLabelSearch: "Search: ",
        incidentsTableThDate: "Date",
        incidentsTableThSubject: "Subject",
        incidentsTableThID: "ID",
        incidentsTableThPriority: "Priority",
        incidentsTableThStatus: "Status",
        incidentsTableThAction: "Action Taken ",
        LogSourcesPageTableThName: "Name",
        LogSourcesPageTableThType: "Type",
        LogSourcesPageTableThIP: "IP",
        LogSourcesPageTableThStatus: "Status",
        logsSourceStatusWidgetTableType: "Type",
        logsSourceStatusWidgetTableStatus: "Status",
        widgetErrorMessage: "An error occurred during data processing.",
        confirmProposal: "Action proposal received",
        highSeverity: "High Severity",
        mediumSeverity: "Medium Severity",
        lowSeverity: "Low Severity",
        myNodes: "Log sources",
        dashboard: "Dashboard",
        incidents: "Incidents",
        reports: "Reports",
        support: "Support",
        lastedFor: "and the downtime lasted for",
        occuredAt: "It was recorded on",
        logsPerDayLogSpaceWarningText: "is running low.",
        logsPerDayLogSpaceWarningTitle: "Logspace",
        systemStatusWidgetLast365DaysTitle: "last 365 days",
        systemStatusWidgetLastMonthSLATitle: "last month (SLA)",
        systemStatusWidgetLatestDowntimeTextPartOne: "It was recorded on",
        systemStatusWidgetLatestDowntimeTextPartTwo:
          "and the downtime lasted for",
        systemStatusWidgetLatestDowntimeTitle: "Latest downtime",
        systemStatusWidgetUsedLogSpaceFreeOf: "free of",
        systemStatusWidgetUsedLogSpaceTitle: "Used log space",
        incidentsPageReportsTitle: "Reports",
        incidentsPageTicketsTitle: "Tickets",
        incidentsReportPageReportDownloadText: "download incident report",
        incidentsReportPageReportTitle: "Reports",
        LayoutApplicationTitle: "SECURITY OPERATIONS CENTER",
        reportsPageDownloadText: "download report",
        TicketsPageTicketsTitle: "Tickets",
        incidentsBecomePlusCustomerP1:
          "In the SOC Start version of the service the customer is responsible for handling alerts and incident response. Cygates recommendation is to document the alerts and incidents in a ticket system. Make sure that a limited number of people have access to incident information as it is usually very sensitive.",
        incidentsBecomePlusCustomerP2:
          "In SOC Plus and Pro incident handling is included, this view will then be activated and provide an overview on security incidents. To get more information on SOC Plus and Pro please contact your Cygate representative.",
        SignInButtonText: "Click to sign in",
        SignOutButtonTitle: "Sign out",
        SignOutPageHeader: "You are now signed out",
        systemStatusWidgetAnd: "and",
        systemStatusWidgetDowntime: "No downtime recorded",
        systemStatusWidgetGB: "GB",
        systemStatusWidgetHours: "hours",
        systemStatusWidgetMinutes: "minutes",
        logSourceWidgetOf: "of",
        logSourceWidgetOnline: "online",
        logSourceWidgetShowMore: "Show more",
        logsPerDayLogSpaceWarningSpaceSuffix: "GB/day",
        technicalAnalysis: "Technical analysis",
        GeneralErrorPageHeader: "An error occurred",
        GeneralErrorPageText:
          "We are very sorry, it seems there is a problem with our servers. We have been notified of the error and will correct it as soon as possible. Please try your request again in a moment.",
        pageErrorMessage: "An error occurred during data processing.",
        pageErrorTitle: "Failed to load content",
        tryAgain: "Try again",
        supportPageCustomerPortalHeader: "Service portal",
        supportPageInitialText:
          "You are welcome to contact Cygate Service Desk for support in two ways where service portal is the recommended one.",
        supportPageReportAProblem1:
          "If you experience any problem with the service, please report it through the Service portal. Select tab <b>create a ticket \"An error has occurred\"</b> and register the problem. Choose <b>category SOC</b>, write a description. Also select appropriate scope and impact when registering. <b>Note!</b> Do not write any security sensitive details.",
        supportPageManagementFormHeader: "Fill in the form to Operations",
        supportPageReportAProblemHeader: "Report a problem (Felanmälan)",
		supportPageRequestForChangeHeader: "Request for change (Förfrågan)",
		supportPageRequestForChange1: "If you need to change anything in your environment that could cause any interference or interruption in the service delivery, please report it through the Service portal to receive approval from Cygate. Cygate will create a change. If Cygate need to perform maintenance of the service, they will initiate changes in a similar way and inform the customer.",
    supportPageRequestForChange2: "Some changes e.g. in log sources system versions can affect the logs format.In these cases, Cygate may need to change the receiver of the logs in the service to maintain the delivery quality of the service.",
    supportPageRequestForChange3: "Select tab <b>create a ticket \"I need to request\"</b> and register the request. Choose <b>category SOC</b>, write a description. <b>Note!</b> Do not write any security sensitive details.",
		supportPageEnhancementRequestHeader: "Enhancement request (Förfrågan)",
		supportPageEnhancementRequest1: "If you have a general question or if you have ideas of service improvement, please create a question through the Service portal.",
supportPageEnhancementRequest2: "All SOC customers have the opportunity, which Cygate also encourages to give feedback and request feature enhancements of the service.",
supportPageEnhancementRequest3: "This feedback is not handled as a regular support ticket but is instead handled by the SOC Service Operations team.",
		supportPagePhoneHeader: "Phone",
        supportPagePhoneNumber: "0771 22 01 10",
        supportPageCustomerSupportURL: "https://customerportal.cygate.se/",
        supportPageTelephoneHours1:
          "Support is available on normal working days 08:00-17:00 and day before holiday 08:00-13:00. During other hours kindly use the Service portal to create a support ticket.",
        supportPageTelephoneHours2:
          "Customers with extended support will have a dedicated number for support specified in their agreement of the service.",
        supportPageTabText: "tab",
        reportsPageDownload: "Download",
        reportsPageHeaderGenerated: "Generated",
        reportsPageHeaderPeriod: "Period",
        reportsPageHeaderTitle: "Title",
        InfoToCustomer: "Info to customer",
        ActionProposal: "Action proposal",
        ActionProposalReceived: "Action proposal",
        ActionProposalImplemented: "Action proposal",
        ActionProposalRejected: "Action proposal",
        CustomerAcknowledgement: "Customer acknowledgement",
        WaitingForCustomerInformation: "Waiting for customer information",
        CommentFromCustomer: "Comment from customer",
        CommentToCustomer: "Comment to customer",
        Closed: "Closed",
        Open: "Open",
        changePassword: "Change password",
        received: "Received",
        implemented: "Implemented",
        rejected: "Rejected",
        ActionProposalActionsToTake: "You have a new action proposal",
        ActionProposalReceivedActionsToTake: "You have actions to take"
      }
    },
    fi: {
      translations: {
        dashboardPageTitle: "dashboard"
      }
    }
  },
  fallbackLng: "sv",
  debug: false,

  // have a common namespace used around the full app
  ns: ["translations"],
  defaultNS: "translations",

  keySeparator: false, // we use content as keys

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ","
  },

  react: {
    wait: true
  }
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js